module.exports = {"522634001":"龙头街道","522634100":"丹江镇","522634101":"西江镇","522634102":"永乐镇","522634103":"郎德镇","522634104":"大塘镇","522634200":"望丰乡","522634203":"达地水族乡","522634204":"方祥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522634.json
// module id = 2657
// module chunks = 0